function initActivities() {
    var maxHeight = 160;
    var activities = document.getElementsByClassName('js_activity');

    for (var i = 0; i < activities.length; i++) {
        var activity = activities[i];
        var content = activity.querySelector('.js_limited-content');
        var btn = activity.querySelector('.js_expand-btn');

        if (content.offsetHeight > maxHeight) {
            btn.classList.add('visible');
            content.classList.add('limited');
        }

        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.target.closest('.js_activity').querySelector('.js_limited-content').classList.toggle('open');
            e.currentTarget.classList.toggle('open');
        });

        activity.style.minHeight = highest + 'px';
    }

    var highest = 0;

    for (var i = 0; i < activities.length; i++) {
        var activity = activities[i];
        var height = activity.offsetHeight;

        if (highest < height) {
            highest = height;
        }
    }

    for (var i = 0; i < activities.length; i++) {
        activities[i].style.minHeight = highest + 'px';
    }
}


naja.addEventListener('complete', function(event) {
    initActivities();
});

document.addEventListener('DOMContentLoaded', function() {
    initActivities();
});
